// extracted by mini-css-extract-plugin
module.exports = {"content":"content___50gD4","title":"title___3S0-G","featuredAuthor":"featuredAuthor___nQZVA"};